/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/statistics/statistics.components.module.ts.
 */
import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {StatisticsArtikelEinkaufComponent} from './components/artikel-einkauf/statistics.artikel-einkauf.component';
import {
  StatisticsArtikelEinkaufViewComponent
} from './components/artikel-einkauf-view/statistics.artikel-einkauf-view.component';


@NgModule({
  declarations: [
    StatisticsArtikelEinkaufComponent,
    StatisticsArtikelEinkaufViewComponent,
  ],
  exports: [
    StatisticsArtikelEinkaufComponent,
    StatisticsArtikelEinkaufViewComponent,
  ],
  imports: [
    SharedModule,
  ],
  providers: []
})
/**
 * Zweck: Beschreibt class StatisticsComponentsModule und ihren Daten- oder Funktionsvertrag.
 */
export class StatisticsComponentsModule {
}
